module.exports = __webpack_public_path__ + "img/med-c1.b12047a2.svg";